import { tableSliceActions } from './tableSlice';

export const tableActions = {
  ...tableSliceActions,
};
